/**
 *  Filename ....: req-summary.component.ts
 *  Created by ..: ianday
 *  on Date .....: 11/15/23
 **/
import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {AgencyResponse} from "../../../models/agency-response";
import {DwUtils} from "../../../components/utils/dw-utils";
import {Settings} from "../../../services/settings";
import {ServiceRequestsService} from "../../../services/service-requests.service";

@Component({
    selector: 'app-req-summary',
    templateUrl: './req-summary.component.html',
    styleUrls: ['./req-summary.component.css']
})

export class RequestSummaryComponent implements OnInit {

    public _requestSummary: any
    public dataSource: MatTableDataSource<AgencyResponse>;
    public displayedColumns: any = ['id', 'agencyName', 'plannedCommitted', 'amount', 'responseDate'];
    public Idx: number = -1;
    public selectedRecord: any;
    public _serviceRequestId: number;
    public _requestStatusId: number;
    public agencyResponses: any;

    @Input() set requestSummary(val: any) {
        this._requestSummary = val;
    }

    @Input() set requestStatusId(val: number) {
        this._requestStatusId = val;
    }

    @Input() set serviceRequestId(val:number) {
        this._serviceRequestId = val;
    }

    public get requestSummary(): any {
        return this._requestSummary;
    }
    constructor(public serviceRequestsService: ServiceRequestsService) {

    }

    ngOnInit() {

    }
    public onShowHandler():void {
        if(this._requestStatusId === 3) {
            this.queryRecords();

        }
    }
    public queryRecords(): void {

        if(this._serviceRequestId === undefined)
            return;

        this.agencyResponses = [];
        this.serviceRequestsService.getAgencyResponsesForServiceId(this._serviceRequestId).subscribe(
            (result) => {

                // this.alreadyProvided = 0;

                for (const rec of result) {
                    result['agencyName'] = Settings.getInstance().getAgencyName(rec.agencyId);
                    //this.alreadyProvided += Number(rec.amountProvided);
                    this.agencyResponses.push(rec);
                }
                this.dataSource = new MatTableDataSource(this.agencyResponses);
                //this.setValues(true);
            },
            (error) => {
                Settings.getInstance().handleError(error, 'Fetching agency response records')
            });
    }
    public onRowClicked(row: any): void {
        this.selectedRecord = row;
        this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
    }
    public tableKeyDown(event: any): void {

        const len: number = this.dataSource.filteredData.length;

        if (event.key === 'ArrowDown') {
            if (this.Idx < (len - 1)) {
                this.selectedRecord = this.dataSource.filteredData[++this.Idx];
                DwUtils.setFocus('contributionsTableId');
            }
        } else if (event.key === 'ArrowUp') {
            if (this.Idx > 0) {
                this.selectedRecord = this.dataSource.filteredData[--this.Idx];
                DwUtils.setFocus('contributionsTableId');
            }
        }
    }
    public getAgencyName(agencyId: number) {
        return Settings.getInstance().getAgencyName(agencyId);
    }
    public showCommitmentColors(statusVal:string) : string {

        if(statusVal === undefined) {
            return '';
        }

        switch(statusVal) {
            case 'Requested':
                return 'orange';
            case 'Planned':
                return 'blue';
            case 'Committed':
                return 'green';

        }
        return '';
    }
}


